import { SETTINGS_KEY, type SettingsRepository } from '../../ports/repositories';

/**
 * O segredo da sessão guardado neste aparelho.
 *
 * Estado do dispositivo, como a obra aberta — não dado de obra. É o que evita pedir
 * e-mail toda manhã no tablet do canteiro. Quem decide se o token ainda vale é quem o
 * resolve; aqui é só onde ele espera.
 */
export class GetSessionToken {
  constructor(private readonly settings: SettingsRepository) {}

  execute(): Promise<string | undefined> {
    return this.settings.get<string>(SETTINGS_KEY.SESSION_TOKEN);
  }
}

export class SetSessionToken {
  constructor(private readonly settings: SettingsRepository) {}

  async execute(token: string): Promise<void> {
    await this.settings.set(SETTINGS_KEY.SESSION_TOKEN, token);
  }
}

export class ClearSessionToken {
  constructor(private readonly settings: SettingsRepository) {}

  async execute(): Promise<void> {
    await this.settings.remove(SETTINGS_KEY.SESSION_TOKEN);
  }
}
